import { PaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ComplaintInternalMessage from '../../models/ComplaintInternalMessage';


export interface ComplaintInternalMessageDetailState extends PaginatedApiState {
  message?: ComplaintInternalMessage
}

export default requestReducer<ComplaintInternalMessageDetailState>('COMPLAINT_INTERNAL_MESSAGE_DETAIL')
